import Api from '@/vuex/api'

import {
  DISPLAY_SIDEBAR,
  LOAD_SIDEBAR,
  ACTIVE_LINK
} from '@/vuex/types'

const api = new Api()

const state = {
  showSidebar: false,
  home: {
    name: 'Home',
    path: '/dashboard'
  },
  sidebarLinks: [],
  currentLink: {}
}

const getters = {
  $sidebar () {
    return state
  }
}

const mutations = {
  [DISPLAY_SIDEBAR] (state, val) {
    state.showSidebar = val
  },
  [LOAD_SIDEBAR] (state, val) {
    state.sidebarLinks = [ state.home, ...val ]
  },
  [ACTIVE_LINK] (state, val) {
    state.currentLink = val
  }
}

const actions = {
  async [LOAD_SIDEBAR] (context) {
    let apps = await api.getSidebar()
    context.commit(LOAD_SIDEBAR, apps)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/sidebar.js